var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaskRobotGarageItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_36000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 112,
    height: 112
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00012207,
    y: 58,
    width: 82.0245,
    height: 82.0245,
    rx: 6.83537,
    transform: "rotate(-45 -0.00012207 58)",
    fill: "url(#paint0_linear_359_36000)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_36000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3816 107.217L62.0473 107.217L57.8389 111.425L53.5792 107.166L52.2448 107.166L48.1904 103.111L45.1111 103.111L57.8389 115.839L70.5153 103.163L67.436 103.163L63.3816 107.217Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_359_36000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 25.063
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_359_36000",
    x: -21.746,
    y: -21.746,
    width: 159.492,
    height: 159.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.3415,
    result: "effect1_foregroundBlur_359_36000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_36000",
    x1: -0.00012207,
    y1: 99.0122,
    x2: 82.0244,
    y2: 99.0122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10161C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskRobotGarageItem);
export default __webpack_public_path__ + "static/media/maskRobotGarageItem.97fe0172376f2deacb723e85dde068a8.svg";
export { ForwardRef as ReactComponent };